const FilDAriane = ({ filDAriane }) => {
    return (
        <div className="baseocom-breadcrumbs">
            {filDAriane?.map(({ title, url }, index) => {
                return (
                    <span key={`fildariane-${index}`}>
                        {index !== filDAriane.length - 1 ? (
                            <a key={index} href={url}>
                                {title}
                            </a>
                        ) : (
                            title
                        )}
                        {index < filDAriane.length - 1 && (
                            <span className="baseocom-chevron">&gt;</span>
                        )}
                    </span>
                )
            })}
        </div>
    )
}
export default FilDAriane
